<div class="form-row">
    <div class="form-group col mb-0">
        <div class="query-builder form-control"
            [ngClass]="{'form-control-sm' : size === 'sm', 'form-control-lg': size === 'lg'}" [attr.disabled]="disabled">
            <div class="query-builder-history-wrapper">
                <button class="btn btn-light text-dark border-0 border-right query-builder-history-button"
                    [ngClass]="{'btn-sm' : size === 'sm', 'btn-lg': size === 'lg'}" (click)="recentSearchesOp.toggle($event)">
                    <fa-icon [icon]="faHistory" [size]="size ?? undefined"></fa-icon>
                    <fa-icon [icon]="['fas', 'caret-down']" class="ml-1"></fa-icon>
                </button>
                <p-overlayPanel #recentSearchesOp [style]="{ 'min-width': '400px', 'border-top-left-radius': '0px', 'border-top-right-radius': '0px' }">
                    <div class="query-builder-dropdown mt-2">
                        <h5 style="padding: 0 1.25rem;">{{ 'common.query-builder.your-recent-searches' | translate }}</h5>
                        <ul class="list-group list-group-small">
                            <li class="list-group-item list-group-item-action"
                                *ngFor="let search of recentSearches | async"
                                (click)="setQueryFromRecentSearch(search, true)">
                                <div class="small text-muted">{{ search.created_at | amLocal | amTimeAgo }}</div>
                                <div *ngFor="let k of search.query | objectToKVP">
                                    {{ k.key | titlecase }}: {{ k.value.label }}
                                </div>
                            </li>
                        </ul>
                    </div>
                </p-overlayPanel>
            </div>

            <div class="token-container-wrapper">
                <ul class="token-container">
                    <li class="token query-token" *ngFor="let token of queries; index as idx">
                        <div class="query-token-inner d-flex" (click)="onEditToken(idx)">
                            <div class="query-token-label border-right" *ngIf="!token.attribute.fulltext">
                                {{ token.attribute.label }}</div>
                            <div class="query-token-value" *ngIf="token.value">
                                {{ token.value.label }}
                                <span class="query-token-remove-wrapper" (click)="removeQueryToken(idx)"
                                    *ngIf="!disabled">
                                    <fa-icon [icon]="['far', 'times']" class="ml-1"></fa-icon>
                                </span>
                            </div>
                        </div>
                    </li>
                    <li class="token input-token">
                        <input
                            #controlInput
                            autocomplete="off"
                            class="form-control"
                            [disabled]="disabled"
                            (click)="inputOp.toggle($event)"
                            [(ngModel)]="controlInputValue"
                            [ngClass]="{'form-control-sm' : size === 'sm', 'form-control-lg': size === 'lg'}"
                            (keydown.backspace)="onInputBackspace($event)" (keydown.enter)="onInputEnter($event)"
                            [attr.placeholder]="queries.length === 0 ? ('common.query-builder.input-placeholder' | translate) + '...' : ''"
                            (input)="controlInputChanged($event)" />
                        <p-overlayPanel #inputOp>
                            <div class="query-builder-dropdown">
                                <ng-container *ngIf="editingIdx === null">
                                    <button (click)="onInputEnter($event)" class="dropdown-item">
                                        <fa-icon [icon]="faSearch" [fixedWidth]="true" class="mr-1">
                                        </fa-icon>{{ 'common.query-builder.enter-or-click-to-search' | translate }}
                                    </button>
                                    <ng-container *ngFor="let token of tokens">
                                        <button
                                            class="dropdown-item"
                                            (click)="addQueryToken(token)"
                                            *ngIf="!controlInputValue || token.label.toLowerCase().startsWith(controlInputValue.toLowerCase())">
                                            <fa-icon [icon]="token.icon" [fixedWidth]="true" class="mr-1"></fa-icon>
                                            {{ token.label }}
                                        </button>
                                    </ng-container>
                                    <button
                                        class="dropdown-item"
                                        (click)="addFTXToken(controlInputValue)"
                                        *ngIf="controlInputValue && fullTextSearch">
                                        {{ 'common.search' | translate }}: "{{ controlInputValue }}"
                                    </button>
                                </ng-container>
                                <ng-container *ngIf="editingIdx !== null">
                                    <ng-container *ngIf="suggestions && suggestions.length > 0; else defaultSuggestions">
                                        <button class="dropdown-item" *ngFor="let suggestion of suggestions"
                                                (click)="setTokenValue(suggestion)">
                                            {{ suggestion.label }}
                                        </button>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </p-overlayPanel>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <ng-container *ngIf="sortOptions && sortOptions.length > 0">
        <div class="form-group col-auto mb-0">
            <div class="input-group input-group-sm">
                <select class="custom-select" [(ngModel)]="selectedSortOption">
                    <option *ngFor="let opt of sortOptions" [ngValue]="opt">{{ opt.label }}</option>
                </select>
                <div class="input-group-append">
                    <button class="btn border bg-white" [disabled]="!selectedSortOption.allowChangeDirection"
                        [ngClass]="{'bg-light text-muted': !selectedSortOption.allowChangeDirection}"
                        (click)="flipSortDirection(selectedSortOption)">
                        <fa-icon
                            [icon]="['fas', selectedSortOption.direction === SORT_DIRECTION.ASC ? 'sort-amount-down' : 'sort-amount-up']">
                        </fa-icon>
                    </button>
                </div>
            </div>
        </div>
    </ng-container>
</div>

<ng-template #defaultSuggestions>
    <div class="m-2">
        <span *ngIf="!controlInputValue && !loadingSuggestions">{{ 'common.query-builder.type-something' | translate }}...</span>
        <span *ngIf="controlInputValue && !loadingSuggestions">{{ 'common.query-builder.no-suggestions-found' | translate }}...</span>
        <span *ngIf="controlInputValue && loadingSuggestions">{{ 'common.searching' | translate }}...</span>
    </div>
</ng-template>
